/**
 * @description 系統參數類型 (enum)
 */
export enum SystemOptionTypesEnum {
  /** 全部 */
  All = 'All',
  /** 受益人保險金分配方式 */
  AllocateBy = 'AllocateBy',
  /** 受益人關係-順位 */
  BfcRelationPrec = 'BfcRelationPrec',
  /** 受益人關係-比例 */
  BfcRelationProp = 'BfcRelationProp',
  /** 受益人關係-順位 (未滿七歲子女) */
  BfcRelationPrecU7 = 'BfcRelationPrecU7',
  /** 受益人關係-比例 (未滿七歲子女) */
  BfcRelationPropU7 = 'BfcRelationPropU7',
 /** 受益人關係(祝壽受益人)-順位 */
  BfcRelationPrecs = 'BfcRelationPrecs',
 /** 受益人關係-(祝壽受益人)比例 */
  BfcRelationProps = 'BfcRelationProps'
}
